<script>
import { orderBy } from 'lodash'
import baseMixin from '@/mixins/baseMixin'
import TimesheetSkeletonLoader from '@/components/skeleton/timesheet-skeleton-loader.vue'
import TimesheetWeekGroup from '@/components/timesheet/timesheet-week-group.vue'

export default {
  name: 'TimesheetExpansionPanelContent',
  components: {
    TimesheetSkeletonLoader,
    TimesheetWeekGroup,
  },
  mixins: [baseMixin],
  props: {
    isDataLoaded: {
      type: Boolean,
      required: true,
    },
    primaryGroupType: {
      type: String,
      default: '',
    },
    /**
     * Id corresponding to the primary group type
     */
    primaryGroupKeyId: {
      type: Number,
      required: true,
    },
    pendingApprovalDisplayable: {
      type: Array,
      default: () => [],
    },
    loadTimesheetHandler: {
      type: Function,
      default: function() {
        return null
      },
    },
  },
  data: () => {
    return {
      isLoading: false,
    }
  },
  computed: {
    orderedWeekGroups() {
      return orderBy(
        this.pendingApprovalDisplayable,
        (weekGroup) => weekGroup.sortDate
      )
    },
  },
  async created() {
    if (!this.isDataLoaded) {
      this.isLoading = true
      await this.loadTimesheetHandler(
        this.primaryGroupType,
        this.primaryGroupKeyId
      )
      this.isLoading = false
    }
  },
  methods: {
    timesheetsUpdated(selectedTimesheets) {
      this.$emit('timesheetsUpdated', selectedTimesheets)
    },
    changeTime(timesheetData) {
      this.$emit('changeTime', timesheetData)
    },
    cancelBookingSubmitted(payload) {
      this.$emit('cancelBookingSubmitted', payload)
    },
  },
}
</script>

<template>
  <div>
    <TimesheetSkeletonLoader v-if="isLoading" />
    <TimesheetWeekGroup
      v-for="group of orderedWeekGroups"
      v-else
      :key="group.title"
      :group="group"
      :primary-group-type="primaryGroupType"
      @timesheetsUpdated="timesheetsUpdated"
      @changeTime="changeTime"
      @cancelBookingSubmitted="cancelBookingSubmitted"
    />
  </div>
</template>
